import React, { useEffect } from 'react';
import styles from './ListItem.scss';

const ListItem = ({ entityName, entityId, isEnrolled, onButtonClick, buttonText }) => {
    return (
    <div className={styles.listItem}>
      <div className={styles.info}>
        <div className={styles.name}>{entityName}</div>
        <div className={styles.id}>{entityId}</div>
      </div>
      <div className={styles.enrolledLabel}>
        {isEnrolled ? (
          <span className={styles.enrolledLabel}><i className="fa fa-check-circle text-sm"/>Enrolled</span>
        ) : (
          <span className={styles.notEnrolledLabel}>Not Enrolled</span>
        )}
      </div>
      <div className={styles.status}>
        {isEnrolled ? (
          <div></div>
        ) : (
          <a
            className={styles.enrollButton}
            onClick={() => onButtonClick(entityId)}
          >
            {buttonText}
          </a>
        )}
      </div>
    </div>
  );
};

export default ListItem;
